import { Component } from '@angular/core';
import { UsersSearchService } from 'src/app/components/search/users-search.service';
import { RelationRequestTableFactory } from 'src/app/components/user-relation-requests/grid-table-factory/user-relation-requests-table';
import { DoctorLinkTableFactory } from '../../grid-table-factory';
import { SuggestedDoctorTable } from '../../grid-table-factory/doctor-link-tables/suggested-doctor-table';
import { UserSearchTableConstructor } from '../../grid-table-factory/search-table';
import { RELATION_REQUESTS_PAGE_CONFIG, RELATION_REQUESTS_TABLES } from '../../relation-request.tokens';
import { DoctorLinkRequestService } from '../../services/doctor-link-request.service';
import { UserRelationRequestService } from '../../services/relation-request.service';
import { ManageRelationRequestComponent } from '../manage-relation-request/manage-relation-request.component';
import { DOCTOR_LINK_TABLES, DOCTOR_PAGE_CONFIG, DoctorLinkRequestListComponent } from './manage-doctor-link';

@Component({
  selector: 'doctor-links-page',
  templateUrl: './doctor-links-page.html',
  styleUrls: ['./doctor-links-page.component.scss'],
  providers: [
    UsersSearchService,
    { provide: ManageRelationRequestComponent, useClass: DoctorLinkRequestListComponent },
    { provide: UserRelationRequestService, useClass: DoctorLinkRequestService },
    { provide: RelationRequestTableFactory, useClass: DoctorLinkTableFactory },
    { provide: UserSearchTableConstructor, useClass: SuggestedDoctorTable },
    { provide: RELATION_REQUESTS_TABLES, useValue: DOCTOR_LINK_TABLES },
    { provide: RELATION_REQUESTS_PAGE_CONFIG, useValue: DOCTOR_PAGE_CONFIG },
  ],
})
export class DoctorLinksPageComponent {}
